import { useCallback, useState } from 'react';

export const useRatingsApi = (isRating?: number) => {
	const [hoverIndex, setHoverIndex] = useState<number | null>(null);
	const [rating, setRating] = useState<number | null>(null);

	const checkIsFilled = useCallback(
		(index: number) => {
			if (hoverIndex !== null) return index <= hoverIndex;
			if (rating !== null) return index <= rating;
			return false;
		},
		[hoverIndex, rating]
	);

	const onHover = useCallback(
		(index: number | null) => () => {
			if (isRating) return;
			setHoverIndex((rating ?? 0) > (index ?? 0) ? rating : index);
		},
		[isRating, rating]
	);

	const setRatingValue = useCallback(
		(index: number) => () => {
			setRating(index);
			setHoverIndex(null);
		},
		[]
	);

	return {
		checkIsFilled,
		hoverIndex,
		onHover,
		setRating: setRatingValue,
		rating: rating === null ? 0 : rating + 1,
	};
};
